module.exports = __webpack_public_path__ + "static/media/0322_IMG_LES_ENSEIGNES_LE_TRAITEUR_SCRABBLE.802efa56.png";